import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
export function StickyCTA() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const toggleVisibility = () => {
      // Show after scrolling past the hero section (approx 600px)
      if (window.scrollY > 600) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <AnimatePresence data-id="element-330">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      scale: 0.9
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 50,
      scale: 0.9
    }} className="fixed bottom-4 right-4 md:bottom-6 md:right-6 z-50" data-id="element-331">
          <button onClick={scrollToPricing} className="bg-terracotta hover:bg-terracotta-600 text-white px-4 py-3 md:px-6 md:py-4 rounded-full font-bold shadow-2xl shadow-terracotta/30 flex items-center gap-2 transition-transform hover:scale-105 active:scale-95 border-2 border-white/20 text-sm md:text-base" data-id="element-332">
            <span data-id="element-333">💥</span>
            <span className="hidden sm:inline" data-id="element-334">Comprar ahora</span>
            <span className="sm:hidden" data-id="element-335">Comprar</span>
          </button>
        </motion.div>}
    </AnimatePresence>;
}